<template>
  <section class="app-main" ref="appMain">

    <!-- {{ $route.meta.keepAlive }} -->
    <!-- <keep-alive>
    <router-view :key="key" ref="pagemain"></router-view>
    </keep-alive> -->

    <template >
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive " :key="key" ref="pagemain"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive "></router-view>
    </template>


  </section>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AppMain',
  inject: ['reload'],
  props: {
    gopath: {
      typeof: String,
      default: ''
    },
  },

  computed: {

    ...mapGetters({
      keepAliveData: 'keepAliveData',
      visitedViews: 'visitedViews',
      showtrue: 'showtrue'
    }),

    keepAliveDatas() {
      return this.keepAliveData || []
    },
    visitedViewsDatas() {

      return this.visitedViewsd
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      // console.log(this.$route)
      return this.$route.fullPath
    },
    showcenc() {
      return window.localStorage.getItem('gotoshow')
    }
  },
  created() {
  },
  data() {
    return {
      visitedViewsd: [],
      gotopath: '',
      gap_time: 0,
      beforeUnload_time: 0,
    }
  },
  watch: {
    $route() {
      this.$refs.appMain.scrollTop = 0
    }
  },

  methods: {

    dd() {
      // this.$refs.pagemain.refresh()
      this.reload()
    },
    gopathd(path) {

    },
    // 根据fullUrl清除keepAlive
    clearKeepAlive(fullUrl) {
      // console.log('bus触发要清除的keepAlive', fullUrl,this.$children);

      this.$children.forEach((item) => {
        if (item.$vnode.data.key == fullUrl) {
          this._myDestory(item);
        }
      });
    },
    // 封装清除某个组件的keepAlive状态,并销毁
    _myDestory(keepAliveComponent) {
      // 你可以根据自己的业务更改此处的判断逻辑，酌情决定是否摧毁本层缓存。
      if (
        keepAliveComponent.$vnode &&
        keepAliveComponent.$vnode.data.keepAlive
      ) {
        if (
          keepAliveComponent.$vnode.parent &&
          keepAliveComponent.$vnode.parent.componentInstance &&
          keepAliveComponent.$vnode.parent.componentInstance.cache
        ) {
          if (keepAliveComponent.$vnode.componentOptions) {
            var key =
              keepAliveComponent.$vnode.key == null
                ? keepAliveComponent.$vnode.componentOptions.Ctor.cid +
                (keepAliveComponent.$vnode.componentOptions.tag
                  ? `::${keepAliveComponent.$vnode.componentOptions.tag}`
                  : "")
                : keepAliveComponent.$vnode.key;
            var cache =
              keepAliveComponent.$vnode.parent.componentInstance.cache;
            var keys = keepAliveComponent.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
      keepAliveComponent.$destroy();
    },
    // 关闭窗口之前执行
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    unloadHandler() {
      this.gap_time = new Date().getTime() - this.beforeUnload_time;
      //判断是窗口关闭还是刷新 毫秒数判断 网上大部分写的是5
      if (this.gap_time <= 10) {
        window.localStorage.clear();
        //logOut() // 退出登录接口 这里应当换为个人的登出方法
      } else {
        console.log(456);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    console.log(123);
  },
  destroyed() {
    // 移除监听
    window.removeEventListener("beforeunload", () => this.beforeunloadHandler());
    window.removeEventListener("unload", () => this.unloadHandler());
  },
  mounted() {
    this.visitedViewsd = Array.from(this.visitedViews)
    // 监听浏览器关闭
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    window.addEventListener("unload", () => this.unloadHandler());
  },

}
</script>

<style scoped>
.app-main {
  width: 100%;
  padding-left: 0.5em;
  padding-right: 0.5em;
  height: calc(100% - 35px);
  position: relative;
  overflow: auto;
  box-sizing: border-box;
}
</style>